import { Outlet } from "react-router-dom"

export const DetailsLayout = () => {
    return <Outlet />
}